import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ApiService } from '../../../api.service';
import { ToastrService } from 'ngx-toastr';
declare var $: any;
import Swal from 'sweetalert2';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { mobilePattern, noWhitespaceInRequiredValidator } from '../../../shared/constants';

@Component({
	selector: 'app-branch-create',
	templateUrl: './branch-create.component.html',
	styleUrl: './branch-create.component.css'
})
export class BranchCreateComponent implements OnInit, AfterViewInit {
	breadcrumbList = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		},
		{
			path: "/app/branch-list",
			name: "Branch"
		}
	];
	uId: any = null;
	pagetitle = "Create Branch";
	moduleForm!: FormGroup;
	showLoader: boolean = false;
	pageLoading: boolean = false;
	details: any = null;
	customError: any = {};
	UserModuleAccess: any = "Full";
	formSubmitted = false;
	companyList: any[] = [];

	constructor(private toastr: ToastrService, private apiService: ApiService, private formBuilder: FormBuilder, private router: Router, private activeRoute: ActivatedRoute) { }
	ngAfterViewInit(): void { }

	ngOnInit(): void {
		this.activeRoute.params.subscribe(routeParams => {
			this.uId = routeParams["uId"] == undefined ? null : routeParams["uId"];
			this.moduleForm = this.formBuilder.group({
				name: [null, [Validators.required, noWhitespaceInRequiredValidator]],
				email: [null, [Validators.required, noWhitespaceInRequiredValidator, Validators.email]],
				phone_no: [null, [Validators.required, noWhitespaceInRequiredValidator, Validators.pattern(mobilePattern)]],
				address: [null, [Validators.required, noWhitespaceInRequiredValidator]],
				company: [null, [Validators.required]]
			});
			this.getCompanyList();
			if (this.uId) {
				this.breadcrumbList.push({ path: "/app/edit-branch/" + this.uId, name: "Edit" });
				this.pagetitle = "Edit Branch";
				this.getDetails();
			} else {
				this.breadcrumbList.push({ path: "/app/create-branch", name: "Create" });
			}
		});
	}

	showError(field: string) {
		if (this.f[field].invalid && (this.formSubmitted || this.f[field].touched || this.f[field].dirty)) {
			return true;
		}
		return false;
	}

	formChanged() {
		this.moduleForm.markAsDirty();
	}

	getCompanyList() {
		this.apiService.getAllCompanyList().subscribe({
			next: (data: any) => {
				this.companyList = data;
			}, error: (error) => {
				this.companyList = [];
				if (error.status == 401) { return }
			}
		});
	}

	getDetails() {
		this.pageLoading = true;
		this.apiService.getBranchDetails(this.uId).subscribe({
			next: (data: any) => {
				this.pageLoading = false;
				this.details = data;
				this.f.name.setValue(this.details.name);
				this.f.email.setValue(this.details.email);
				this.f.phone_no.setValue(this.details.phone_no);
				this.f.address.setValue(this.details.address);
				this.f.company.setValue(this.details.company);
			}, error: (error) => {
				this.pageLoading = false;
				if (error.status == 401) { return }
				this.toastr.error("Unable to fetch details.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	get f() { return this.moduleForm.controls; }

	clearCustomError() {
		Object.keys(this.f).forEach(key => {
			if (this.f[key].hasError('incorrect')) {
				try {
					delete this.f[key].errors?.incorrect;
					this.f[key].updateValueAndValidity();
				} catch (error) {

				}

			}
		});
		this.customError = {};
	}

	saveData() {
		this.formSubmitted = true;
		this.clearCustomError();
		if (this.moduleForm.invalid) {
			this.toastr.info("Please check required parameters.", 'Warning', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		let payload: any = {
			name: this.f.name.value,
			email: this.f.email.value,
			phone_no: this.f.phone_no.value,
			address: this.f.address.value,
			company: [this.f.company.value]
		};
		let action = "create";
		if (this.uId) {
			payload["id"] = this.uId;
			action = "edit";
		}
		this.showLoader = true;
		this.apiService.createUpdateBranch(payload, action).subscribe({
			next: data => {
				this.showLoader = false;
				this.toastr.success("Saved successfully.", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.gotoList();
			}, error: (error: any) => {
				this.showLoader = false;
				if (error.status == 401) { return }
				if (error.status == 409) {
					Swal.fire({
						title: 'Already Exists',
						html: 'Branch already exists. Do you want to restore it?',
						icon: 'question',
						showCancelButton: true,
						showConfirmButton: true,
						confirmButtonText: 'Yes, Restore!',
						cancelButtonText: 'Cancel',
						confirmButtonColor: '#3e4fb1'
					}).then((result) => {
						if (result.value) {
							this.apiService.restoreBranch(error.error.id).subscribe({
								next: (data: any) => {
									this.toastr.success("Branch restored successfully", 'Success', {
										timeOut: 3000,
										tapToDismiss: true,
										closeButton: true
									});
									this.gotoList();
								}, error: (error) => {
									this.toastr.error("Something went wrong", 'Error', {
										timeOut: 3000,
										tapToDismiss: true,
										closeButton: true
									});
								}
							});
						} else if (result.dismiss === Swal.DismissReason.cancel) { }
					})
				} else {
					let errorMsg: any = "Something went wrong.";
					if (error.status == 400) {
						errorMsg = error.error;
						if (typeof errorMsg == 'object') {
							for (const [key, value] of Object.entries(errorMsg)) {
								let val: any = value;
								if (val == "This field must be unique.") {
									val = "Already exists";
								}
								if (this.moduleForm.controls[key]) {
									this.moduleForm.controls[key].setErrors({ incorrect: true });
									this.customError[key] = val;
									let selector = "#" + key;
									try {
										$('html, body').animate({
											scrollTop: $(selector).offset().top - 60 + 'px'
										}, 'fast');
									} catch (error) { }
									$(selector).focus();
								} else {
									this.toastr.error(key + ":" + val, 'Error', {
										timeOut: 3000,
										tapToDismiss: true,
										closeButton: true
									});
								}

							}
							return;
						}
					} else {
						errorMsg = error.error;
					}
					this.toastr.error(errorMsg, 'Error', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
				}
			}
		});
	}

	gotoList() {
		this.router.navigate(['/app/branch-list']);
	}
}
